import { postImage } from "../utils/api/postImage";

type ImageHandler = (file: any) => Promise<string>;

export const useImageUploader = (subdomain: string) => {
  const uploadImage: ImageHandler = async (file: File | string) => {
    if (typeof file === 'string') return file;

    const formData = new FormData();
    const location = `${subdomain}/images/message-board`;

    formData.append('picture', file);
    formData.append('location', location);

    try {
      const response = await postImage(formData);
      return response?.data?.file_url || '';
    } catch {
      throw new Error('画像のアップロードに失敗しました');
    }
  };

  return { uploadImage };
};
